document.addEventListener('DOMContentLoaded', function () {
  // Reserved for future interactions (mobile nav toggle, etc).
  // Product file-card hover states are handled entirely in CSS.
});
